import { Flex, Form, Radio, type RadioChangeEvent } from 'antd';
import type { NamePath } from 'antd/es/form/interface';

type RadioOption = {
  label: string;
  value: string;
};

type Props = {
  name: NamePath;
  label: string;
  options: RadioOption[];
  initialValue?: string;
  className?: string;
  radioClassName?: string;
  labelClassName?: string;
  onRadioChange?: (e: RadioChangeEvent) => void;
};

const LabelWithRadio = ({
  name,
  label,
  options,
  initialValue,
  onRadioChange,
  className = '',
  radioClassName = '',
  labelClassName = '',
}: Props) => {
  return (
    <Flex
      align="center"
      justify="space-between"
      className={`w-full ${className}`}
    >
      <span className={`block text-white ${labelClassName}`}>{label}</span>

      <div onClick={(e) => e.stopPropagation()}>
        <Form.Item name={name} initialValue={initialValue} className="!mb-0">
          <Radio.Group
            onChange={onRadioChange}
            className={`flex benefit-radio-btn ${radioClassName}`}
          >
            {options.map((option) => (
              <Radio.Button key={option.value} value={option.value}>
                {option.label}
              </Radio.Button>
            ))}
          </Radio.Group>
        </Form.Item>
      </div>
    </Flex>
  );
};

export default LabelWithRadio;
